const EMAIL_REGEX = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/

export class ResforEmail {
  private _email: string

  constructor (email: string) {
    if (EMAIL_REGEX.test(email) === false) {
      throw new TypeError('Email provided has wrong format')
    }
    this._email = email
  }

  email (): string {
    return this._email
  }
}
